// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, label, h1, h2, h3, h4, h5 {
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mi-perfil/mi-perfil.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB","sourcesContent":["body, label, h1, h2, h3, h4, h5 {\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
